import styles from './Slideshow.module.css';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function SlideshowTextOnly({ title, items }) {

    // Slideshow text animations:
    // Slow fade up for body text in all slides except for the last one

    // Last slide has a second line of text that just fades on. 



    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        fade: true,
        pauseOnFocus: true,

        adaptiveHeight: true,
        appendDots: dots => (<div><ul>{dots}</ul></div>),
        customPaging: i => (<div style={{ width: '100px', height: '2px', backgroundColor: 'white' }}></div>)


    }
    return (
        <div className={`${styles.slideshow} ${styles.textOnly}`}>
            <Slider {...settings}>
                {items.map((item, i) => {
                    const key = item?.sys?.id ?? i;

                    return (
                        <div className={styles.slide} key={key}>
                            <p>{item.fields.cornerText}</p>
                            <h2>{item.fields.bodyText}</h2>
                        </div >
                    );
                })}

            </Slider>
        </div>
    );
}

export default SlideshowTextOnly;